import { ListGroup, LoadingFit } from "../../../share/Components";
import { TextBoxTypeEnum } from "../../../enums/TextBoxTypeEnum";
import {
  Button,
  CheckBox,
  DatePicker,
  Icon,
  ProvideTypeahead,
  Select,
  TextBox,
  Typeahead,
} from "../../../share/Elements";
import Card from "../../../share/Components/Card/Card";
import { ItemType } from "../../../models/ViewModels/RecordCatalogViewModel";
import {
  ComplaintType,
  ComplaintTypeItem,
} from "../../../models/ViewModels/RecordViewModel";
import useFetch from "../../../_services/fetch";
import { RaytebRequests } from "../../../_services";
import { useSelector } from "react-redux";
import { ReducerType } from "../../../storeManager/ReducerType";
import { LoginInterface } from "../../../Interfaces/LoginInterface";
import { useState } from "react";
import { toast } from "react-toastify";

type TypeaheadData = {
  show: boolean;
  data?: any;
};
const RecordPatientComplaint = ({
  catalogs,
  item,
  onItemChange,
}: {
  catalogs?: Array<ItemType<string>>;
  item?: ComplaintType;
  onItemChange: (updatedItem: ComplaintType) => void; // A function to handle item changes
}) => {
  const [complaint, setComplaint] = useState<ComplaintTypeItem>({
    dateofOnset: new Date().toDateString(),
    symptomType: 1,
    timeofOnset: new Date().getFormattedTime(),
  });

  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  );
  const getSymptom = useFetch<
    Array<ItemType<string>>,
    unknown,
    {
      filter: string;
    }
  >({
    request: RaytebRequests.Profile_GetDisease_GET({ token: user.token }),
    onSuccess(data) { },
  });
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
  });

  const handleAbstractClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems[index] = {
      ...updatedItems[index],
      showAbstract: !updatedItems[index].showAbstract,
    };

    const checkupData: ComplaintType = {
      ...item,
      items: updatedItems,
    };
    onItemChange && onItemChange(checkupData);
  };
  const handleDeleteClick = (index: number) => {
    const updatedItems = [...(item?.items || [])];
    updatedItems.splice(index, 1);

    const updatedObject = { ...item, items: updatedItems };

    onItemChange && onItemChange(updatedObject);
  };
  const handleTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setComplaint({ ...complaint, timeofOnset: event.target.value });
  };

  const selectedItem = (item: ItemType<string>) => {
    const updatedItem: ComplaintTypeItem = {
      ...complaint,
      diseaseId: item.id,
      disease: item.title,
    };
    setComplaint(updatedItem);
    setshowList({ ...showList, show: false });
  };
  const handleAddItem = () => {
    if (!complaint.diseaseId) toast.error("یک مورد انتخاب کنید");
    else if (!complaint.dateofOnset) toast.error("تاریخ را انتخاب کنید");
    else if (!complaint.timeofOnset) toast.error("مقدار ساعت را انتخاب کنید");
    else {
      const updatedItems = item?.items ? [...item.items] : [];
      updatedItems.push(complaint);

      const updatedComplainType: ComplaintType = {
        ...item,
        items: updatedItems,
      };
      onItemChange(updatedComplainType);
      setComplaint({
        description: "",
        timeofOnset: new Date().getFormattedTime(),
        disease: "",
        symptomType: 1,
      });
    }
  };
  return (
    <>
      <div className="p-6 ">
        <ProvideTypeahead
          className={` ${true ? "before:absolute before:z-50 " : ""}`}
          showList={showList.show}
          listChildren={
            <ListChildren
              onClick={(item) => {
                selectedItem(item);
              }}
              listData={getSymptom.result}
              isLoading={getSymptom.isLoading}
              onHide={() => setshowList({ show: false })}
            />
          }
        >
          <div className="px-1 flex justify-start  items-end md:!w-1/2 md:mx-auto ">
            <Typeahead
              innerText="علائم  بیماری ..."
              className="before:absolute before:bg-white/30 before:w-full before:h-full"
              onClick={(e) => {
                e.target.select();
              }}
              // onBlur={() => setshowList({ ...showList, show: false })}
              onFocus={() => setshowList({ ...showList, show: true })}
              onChange={(e) => {
                if (e.target.value)
                  getSymptom.reFetch(null, {
                    filter: e.target.value,
                  });
              }}
              value={complaint.disease}
            ></Typeahead>
          </div>
        </ProvideTypeahead>
        <div className="mt-4 grid xs:grid-cols-3 grid-cols-9 gap-1">
          <DatePicker
            innerText="تاریخ"
            isRequired={false}
            className=""
            name="Date"
            id="Date"
            raytebValue={complaint?.dateofOnset}
            value={
              complaint?.dateofOnset
                ? new Date(complaint.dateofOnset).toShamsi()
                : ""
            }
            onChange={(e) => {
              const fromDateInput = document.getElementById("Date"); // Assuming you have an element with id "toDate"
              const raytebValue = fromDateInput?.getAttribute("rayteb-value");
              const updatedItem: ComplaintTypeItem = {
                ...complaint,
                dateofOnset: raytebValue!,
              };
              setComplaint(updatedItem);
            }}
          />
          <TextBox
            className="w-full h-9"
            Regular="^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$"
            RxgMessage="از 00:00 تا 23:59"
            innerText="ساعت"
            isRequired={false}
            debounceTime={0}
            Type={TextBoxTypeEnum.Time}
            value={complaint?.timeofOnset!}
            onChange={handleTimeChange}
          />
          <Select
            className="w-24 h-9"
            onChange={(e) => {
              if (e.target.value && e.target.value !== "") {
                setComplaint({ ...complaint, symptomType: e.target.value });
              }
            }}
            value={complaint.symptomType}
          >
            {catalogs?.map((n, i) => (
              <option key={i} value={n.id}>
                {n.title}
              </option>
            ))}
          </Select>
        </div>
        <div className="mt-4 grid grid-cols-9 gap-1">
          <div className="col-span-8">
            <TextBox
              innerText="توضیحات"
              debounceTime={0}
              className="w-full "
              Type={TextBoxTypeEnum.Text}
              value={complaint?.description}
              onChange={(e) =>
                setComplaint({ ...complaint, description: e.target.value })
              }
            />
          </div>
          <Icon
            icon="rayteb-microphone"
            className="text-xl w-full text-disable h-full rounded-full  "
          />
        </div>
        <div className="mt-4 flex justify-between items-center gap-7">
          <div className="flex justify-between gap-4 items-center w-full">
            <div className="mr-3 mb-2"></div>
            <Icon
              icon="rayteb-add-circular"
              className="text-xl text-primaryLight"
              onClick={handleAddItem}
            />
          </div>
        </div>
        <div className="mt-4 grid grid-cols-1 gap-1">
          {item?.items?.map((n, i) => (
            <Card
              key={i}
              text={n.disease}
              footer={
                <CardFooter
                  complaintItem={n}
                  onAbstractClick={() => handleAbstractClick(i)}
                  onDeleteClick={() => handleDeleteClick(i)}
                />
              }
            >
              <span className="text-sm text-primaryLight">
                {new Date(n.dateofOnset!).toShamsi()}
              </span>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
};

const CardFooter = ({
  complaintItem,
  onAbstractClick,
  onDeleteClick,
}: {
  complaintItem?: ComplaintTypeItem;
  onAbstractClick: () => void;
  onDeleteClick: () => void;
}) => (
  <>
    <div className="w-full flex justify-between items-center py-3">
      <Button className="bg-white border border-disable py-1 text-xs text-primary">
        {complaintItem?.description}
      </Button>

      <div className="flex justify-center itmes-center gap-2">
        <Icon
          icon="rayteb-delete"
          className="text-xl text-primary"
          onClick={onDeleteClick}
        />
        <Icon
          icon="rayteb-medical-ophthalmology"
          className={`text-xl  ${complaintItem?.showAbstract ? "text-primary" : "text-disable"
            }`}
          onClick={onAbstractClick}
        />
      </div>
    </div>
  </>
);
type ListChildrenType = {
  listData?: Array<ItemType<string>>;
  className?: string | undefined;
  isLoading: boolean;
  onHide?: () => void;
  onClick?: (param: ItemType<string>) => void;
};
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className="border-b border-disable bg-white py-2 px-1 flex items-center">
          <Icon
            icon="rayteb-android-close"
            className="text-xl"
            onClick={() => onHide?.()}
          />

          <p className="text-xs mr-2 font-bold text-warn ">علائم بیماری ...</p>
        </div>

        <div className="h-64 overflow-y-auto">
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm  ${className ?? ""}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className="flex justify-start items-center  h-8 py-1  w-full hover:bg-primaryDefault hover:cursor-pointer"
                onClick={() => {
                  console.log("click");
                  onClick?.(n);
                }}
              >
                <p className="text-xs font-bold text-end text-primaryLight">
                  {n.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};
export default RecordPatientComplaint;
